/**
 * Footer that appears on the sign up page
 */
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';
import Typography from '@material-ui/core/Typography';
import classnames from 'classnames';

const propTypes = {
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
  }).isRequired,
  className: PropTypes.string,
};

const defaultProps = {
  className: null,
};

export function UnstyledSignUpFooter({ className, classes }) {
  return (
    <footer className={classnames(className, classes.root)}>
      <Typography variant="body2" align="center">
        &copy; {new Date(Date.now()).getFullYear()} Rackspace, US Inc.
        <span className="divider">|</span>
        <a href="http://objectrocket.com/legal" target="_blank" rel="noreferrer noopener">
          Privacy Statement
        </a>
      </Typography>
    </footer>
  );
}

UnstyledSignUpFooter.propTypes = propTypes;
UnstyledSignUpFooter.defaultProps = defaultProps;

const styles = (theme) => ({
  root: {
    padding: theme.spacing(1),
    fontFamily: ['OpenSans', 'sans-serif'].join(','),
    '& .divider': {
      padding: '0 .5rem',
    },
    '& a': {
      marginLeft: '2px',
      color: theme.customColors.white,
      textDecoration: 'none',
    },
  },
});

export default withStyles(styles)(UnstyledSignUpFooter);
